module.exports = __webpack_public_path__ + "dbe20baba310e28ac16f12e784542675.pdf";